import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { LocalCurrencyNote } from './LocalCurrencyNote';
import { useCountdown } from '../hooks/useCountdown';
import { markCheckoutStarted } from '../hooks/useExitIntent';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '🔴',
    title: 'Módulo 1 — Fundamentos y Sistema de Chakras',
    sessions: '~50 páginas',
    months: 'Base conceptual sólida',
    desc: 'Base conceptual sólida para comprender el sistema energético completo y trabajar con criterio profesional.',
    color: 'bg-[#DC2626]',
    borderColor: 'border-t-[#DC2626]'
  }, {
    emoji: '🟠',
    title: 'Módulo 2 — Anatomía Energética y Cuerpos Sutiles',
    sessions: '~50 páginas',
    months: 'Campo energético integral',
    desc: 'Campo energético integral: cuerpos sutiles, capas del aura y cómo interactúan con cada chakra.',
    color: 'bg-[#EA580C]',
    borderColor: 'border-t-[#EA580C]'
  }, {
    emoji: '🟡',
    title: 'Módulo 3 — Técnicas de Armonización y Equilibrio',
    sessions: '~50 páginas',
    months: 'Herramientas prácticas listas',
    desc: 'Herramientas prácticas listas para aplicar en sesión y devolver el equilibrio a cada centro energético.',
    color: 'bg-[#EAB308]',
    borderColor: 'border-t-[#EAB308]'
  }, {
    emoji: '💚',
    title: 'Módulo 4 — Herramientas y Terapias Complementarias',
    sessions: '~50 páginas',
    months: 'Cristales, sonidos y mantras',
    desc: 'Cristales, sonidos y mantras integrados a tu práctica para ampliar los recursos de cada sesión.',
    color: 'bg-[#16A34A]',
    borderColor: 'border-t-[#16A34A]'
  }, {
    emoji: '💜',
    title: 'Módulo 5 — Emociones, Creencias y Bloqueos',
    sessions: '~50 páginas',
    months: 'Dimensión emocional profunda',
    desc: 'Dimensión emocional profunda: cómo identificar y liberar los bloqueos que sostienen el desequilibrio.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '🔵',
    title: 'Módulo 6 — Profesionalización y Práctica Terapéutica',
    sessions: '~50 páginas',
    months: 'Metodología y organización',
    desc: 'Metodología y organización para llevar tu práctica a un nivel profesional, con estructura y seguimiento.',
    color: 'bg-[#2563EB]',
    borderColor: 'border-t-[#2563EB]'
  }];
  const features = ['Objetivo claro y visible', 'Conceptos organizados progresivamente', 'Técnicas listas para aplicar en sesión', 'Recursos de meditación y visualización', 'Material de consulta permanente', 'Herramientas complementarias integradas', 'Una temática por módulo — sin contenido disperso'];
  const featureChips = ['✅ Chakras + Energía + Herramientas', '✅ Sistema completo e integrado', '✅ Técnicas para todo tipo de sesión', '✅ Meditaciones y visualizaciones', '✅ 475 páginas especializadas', '✅ Consulta permanente'];
  return <Section className="bg-bg-base !pt-3 md:!pt-8" data-id="element-18" data-mp="vnyd1f3ynxmg">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19" data-mp="qnk7q4tqv1s4">
        {/* Gold trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20" data-mp="lo7lnmap5yql">
          <span className="inline-flex items-center gap-1.5 font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] px-3 py-1 md:px-3.5 md:py-1.5 rounded-full" style={{
          background: 'linear-gradient(135deg, #D4A41C 0%, #F0BE2A 50%, #D4A41C 100%)',
          color: '#1A1303',
          boxShadow: '0 0 20px rgba(212,164,28,0.4)'
        }} data-id="element-21" data-mp="loplsu0hcx3s">
            🏆 Biblioteca Profesional N°1 para Terapeutas Energéticos
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase text-txt-primary mb-3 md:mb-4 md:text-[36px] text-[22px] leading-[1.25]" data-id="element-22" data-mp="10m9n9qy64a57">
          🔮 BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS{' '}
          <span className="text-brandViolet" data-id="element-23" data-mp="1sc4czopxu1ue">CHAKRAS™</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-24" data-mp="1satd3zzm5e8k">
          6 Módulos + 5 Bonos — 475 páginas · Todo organizado · Consulta
          permanente.
        </p>
      </FadeIn>

      {/* Colored module strip */}
      <FadeIn delay={0.2} className="mb-5 md:mb-8" data-id="element-25" data-mp="13vj0g56g2awz">
        <div className="flex justify-center gap-2 md:gap-4 px-2 md:px-0" data-id="element-26" data-mp="17v9x2pinjl9f">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[46px] md:w-28 h-[60px] md:h-36 rounded-md md:rounded-lg shadow-lg flex flex-col items-center justify-center gap-0.5 md:gap-2 p-1 md:p-3 text-center text-white relative overflow-hidden transform hover:-translate-y-1 transition-transform border border-white/20`} data-id="element-27" data-mp="1vle476v1u356" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-28" data-mp="1qtm86gt4j57n"></div>
              <span className="font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[7.5px] md:text-[10px] leading-tight drop-shadow-md relative z-10" data-id="element-29" data-mp="2eixdmblf5ns4">
                Módulo {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-3 md:mt-4" data-id="element-30" data-mp="7tdae31e5btu">
          <span className="inline-block bg-brandViolet text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full" data-id="element-31" data-mp="2vlktfo7y1st">
            6 MÓDULOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-32" data-mp="3l29iwlkupooz">
        <div className="flex flex-wrap justify-center gap-x-1 gap-y-1 md:gap-x-1.5 md:gap-y-1.5 max-w-3xl mx-auto" data-id="element-33" data-mp="3l2rq2d91xnbo">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandViolet/10 text-brandViolet border border-brandViolet/30 px-1.5 py-0.5 md:px-2 md:py-1 rounded-full font-sans font-bold uppercase tracking-[0.5px] md:tracking-[1px] text-[8.5px] md:text-[10px] whitespace-nowrap" data-id="element-34" data-mp="3v05vzixcmtpq" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.35} className="text-center mb-5 md:mb-7" data-id="element-35" data-mp="15bwx5b1m467b">
        <div className="inline-flex items-center gap-2 bg-bg-card border border-brandViolet/30 rounded-full px-4 py-1.5 md:px-5 md:py-2" data-id="element-36" data-mp="1cebrda1i7qzf">
          <span className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] md:text-[13px] text-brandViolet" data-id="element-37" data-mp="1hcdbzzekvyd0">
            📦 Lo que recibes:
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-12 md:mb-16" data-id="element-38" data-mp="1rajas8538odn">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-39" data-mp="ymdr7oprt5fe" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-bg-card rounded-[16px] md:rounded-[20px] p-4 md:p-6 border-x border-b transition-all border-t-[3px] ${isOpen ? 'border-brandViolet shadow-[0_0_40px_rgba(139,92,246,0.2)]' : `border-x-line border-b-line ${tomo.borderColor}`}`} aria-expanded={isOpen} data-id="element-40" data-mp="yksrzlsigyb7">
                <div className="flex items-start justify-between gap-3" data-id="element-41" data-mp="fv4el6kpe0jl">
                  <div className="flex items-start gap-2.5 md:gap-3 min-w-0 flex-1" data-id="element-42" data-mp="2t6yt86q7s6j2">
                    <div className="text-2xl md:text-4xl shrink-0" data-id="element-43" data-mp="2p5dai4r00y0y">
                      {tomo.emoji}
                    </div>
                    <div className="min-w-0" data-id="element-44" data-mp="2k4xz3iqa20lm">
                      <h3 className="font-sans font-bold text-[14px] md:text-[17px] text-txt-primary leading-snug mb-1.5 md:mb-2" data-id="element-45" data-mp="2k7txf861eral">
                        {tomo.title}
                      </h3>
                      <div className="flex flex-wrap gap-1.5" data-id="element-46" data-mp="2a9nv4pgbjj57">
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-brandViolet bg-brandViolet/10 px-2 py-0.5 rounded" data-id="element-47" data-mp="25gb98n30xqg5">
                          {tomo.sessions}
                        </span>
                        <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[11px] text-txt-muted bg-white/5 px-2 py-0.5 rounded" data-id="element-48" data-mp="1welizkkvoxjy">
                          {tomo.months}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandViolet text-white rotate-180' : 'bg-bg-highlight text-txt-primary hover:bg-line'}`} data-id="element-49" data-mp="3fe16lfhqc34j">
                    {isOpen ? <Minus size={14} data-id="element-50" data-mp="36c1qqqigb536" /> : <Plus size={14} data-id="element-51" data-mp="36bi8f8ow2eom" />}
                  </div>
                </div>
                <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3 md:mt-4' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-52" data-mp="2rnnghuipgecl">
                  <div className="overflow-hidden" data-id="element-53" data-mp="2ioaflq8ncy3h">
                    <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-54" data-mp="2iplgniapjrqw">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-55" data-mp="2dnmdo9ivqwuh">
        <div className="bg-bg-card rounded-[20px] p-5 md:p-10 border border-line max-w-4xl mx-auto" data-id="element-56" data-mp="2do5t9jl2595c">
          <h3 className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug mb-5 md:mb-8" data-id="element-57" data-mp="1u35q5or3thp6">
            Cada módulo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2.5 md:gap-4" data-id="element-58" data-mp="24239md9oal1b">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-59" data-mp="1z0dxeuaps1bn" data-mpi={i}>
                <CheckCircle2 className="text-success shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-60" data-mp="2d0yffo8t1t43" />
                <span className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body" data-id="element-61" data-mp="290y2y959nrzo">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mt-6 md:mt-8 text-center" data-id="element-62" data-mp="2hsq6dzvvi0ur">
            <p className="font-sans font-bold text-base md:text-xl text-brandViolet leading-snug" data-id="element-63" data-mp="2ht8djrk2pzhg">
              Abres la BIBLIOTECA, eliges el módulo y tienes todo listo para
              profundizar y aplicar. Así de simple. 475 páginas de formación
              especializada. Organizadas desde hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🌸',
    title: '365+ Afirmaciones para Cada Chakra',
    desc: 'Una afirmación por día para trabajar los siete chakras. Listas para usar en sesiones y rutinas.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/224NFKMjX1ewtg87H8WET9/BONO_1.webp'
  }, {
    num: '02',
    icon: '🔥',
    title: '100 Rituales de Limpieza y Protección Energética',
    desc: 'Prácticas con sahumerios, cristales, sonidos y visualizaciones. Listas para aplicar.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/uCboZbsmRPUTJDrLCANimS/BONO_2.webp'
  }, {
    num: '03',
    icon: '🧘',
    title: 'Manual de Meditaciones Guiadas para Cada Chakra',
    desc: 'Meditaciones listas para usar en sesiones individuales o grupales. Con guía paso a paso.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/37aTwccLzKgxijatTrN72q/BONO_3.webp'
  }, {
    num: '04',
    icon: '📋',
    title: 'Agenda Profesional del Terapeuta Energético',
    desc: 'Registra consultas, planifica sesiones y lleva el seguimiento de cada consultante.',
    value: 'USD $8',
    image: 'https://cdn.magicpatterns.com/uploads/xzPDko8299kyfAuKDBbfzb/BONO_4.webp'
  }, {
    num: '05',
    icon: '🔮',
    title: 'Manual de Símbolos, Mantras y Frecuencias Sagradas',
    desc: 'Recursos vibracionales y simbólicos listos para incorporar a tus meditaciones y sesiones.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/pbEkeC2ydoHmQxUZS95khB/BONO_5.webp'
  }];
  return <Section className="bg-bg-alt" data-id="element-64" data-mp="woncpddgsw1t">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-65" data-mp="wovn8ym47p9u">
        <h2 className="font-display font-extrabold uppercase md:text-[40px] text-txt-primary mb-2 md:mb-4 text-[26px]" data-id="element-66" data-mp="2ug84dcf3g9m6">
          +5 BONOS <span className="text-brandViolet" data-id="element-67" data-mp="2yhjvjmdm92wh">EXCLUSIVOS</span>
        </h2>
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.7] text-txt-body" data-id="element-68" data-mp="5lrw62x66m0r">
          Materiales complementarios — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-69" data-mp="enrdyxg0du4r">
        {bonuses.map((bono, i) => <FadeIn key={bono.num} delay={Math.min(i * 0.05, 0.2)} data-id="element-70" data-mp="akl83qwt64yt" data-mpi={i}>
            <article className="bg-bg-card rounded-[16px] border border-line border-l-[3px] border-l-brandViolet h-full overflow-hidden flex gap-3 p-3 md:gap-4 md:p-4" data-id="element-71" data-mp="olffc684dzvw">
              <img src={bono.image} alt={`Portada del bono ${bono.num}: ${bono.title}`} loading="lazy" decoding="async" width={128} height={171} className="w-24 self-start aspect-[3/4] shrink-0 rounded-[10px] object-cover border border-white/10 md:w-32" data-id="element-72" data-mp="jk8aog19xgtg" />
              <div className="min-w-0 flex flex-1 flex-col" data-id="element-73" data-mp="17b5et6mtv9u5">
                <div className="flex items-center justify-between gap-2 mb-1.5" data-id="element-74" data-mp="12cu28o55el88">
                  <div className="flex items-center gap-1.5" data-id="element-75" data-mp="12ar39em0phrd">
                    <span className="text-lg md:text-xl" data-id="element-76" data-mp="1lznjejc1nz6f">🎁</span>
                    <span className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandViolet" data-id="element-77" data-mp="1qxglb06be70w">
                      BONO {bono.num}
                    </span>
                  </div>
                  <span className="text-lg md:text-xl" aria-hidden="true" data-id="element-78" data-mp="1gyrfi5rp0d10">{bono.icon}</span>
                </div>
                <h3 className="font-sans font-bold text-[13.5px] md:text-[15px] text-txt-primary leading-snug mb-1 md:mb-1.5" data-id="element-79" data-mp="1373301dj7mji">
                  {bono.title}
                </h3>
                <p className="font-sans text-[12px] md:text-[13.5px] leading-[1.45] md:leading-[1.55] text-txt-body mb-2.5 md:mb-3" data-id="element-80" data-mp="tagjbfwxz1j2">
                  {bono.desc}
                </p>
                <div className="mt-auto pt-2 md:pt-2.5 border-t border-line flex items-center justify-between gap-2" data-id="element-81" data-mp="k9a3za613wre">
                  <span className="font-sans font-normal text-[12px] md:text-[14px] line-through text-danger" data-id="element-82" data-mp="p8v3blp4274n">
                    {bono.value}
                  </span>
                  <span className="bg-success text-white font-sans font-bold uppercase tracking-[1px] text-[8.5px] md:text-[10px] px-2 py-0.5 rounded-full" data-id="element-83" data-mp="h9i1zd6pzyx0">
                    GRATIS
                  </span>
                </div>
              </div>
            </article>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-bg-card p-5 md:p-8 rounded-[20px] border border-line max-w-2xl mx-auto" data-id="element-84" data-mp="3eftciahnvgi">
        <p className="font-sans text-[14px] md:text-[16px] leading-[1.6] text-txt-body mb-2" data-id="element-85" data-mp="3pmxlveqq3q4e">
          Valor total de los 5 Bonos
        </p>
        <p className="font-sans font-normal text-[16px] md:text-[18px] line-through text-danger mb-2" data-id="element-86" data-mp="3konqp4500pis">
          USD $40
        </p>
        <p className="font-display font-black text-[20px] md:text-[36px] leading-[1.15] mb-1 md:mb-2 text-[#22C55E]" data-id="element-87" data-mp="1ix0u8n2c82ex">
          🎁 GRATIS — CON TU BIBLIOTECA
        </p>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-muted" data-id="element-88" data-mp="1ew75xskzglli">
          Incluidos en tu Biblioteca, sin costo extra.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden" data-id="element-89" data-mp="36jndp76y44su">
      <div className="max-w-[1100px] mx-auto" data-id="element-90" data-mp="3aj5qtgsizbl4">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-91" data-mp="2du6gzxcam1qt">
          <div className="rounded-[20px] border-2 border-brandViolet p-6 md:p-10 text-center space-y-6 bg-bg-card max-w-lg mx-auto shadow-[0_0_50px_rgba(139,92,246,0.2),inset_0_0_30px_rgba(139,92,246,0.03)]" data-id="element-92" data-mp="2dvhrsh45o9rf">
            <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandViolet" data-id="element-93" data-mp="2mtber1g15r1x">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex justify-center gap-2.5 md:gap-4 text-white animate-glow-button" data-id="element-94" data-mp="23lyql3lbz7n">
              <div className="bg-bg-card border-2 border-brandViolet rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(139,92,246,0.4)]" data-id="element-95" data-mp="72p4k7rea9go">
                <div className="font-display font-black text-[34px] md:text-[46px] text-brandViolet leading-none" data-id="element-96" data-mp="1z4i1b3grxebn">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandViolet mt-1" data-id="element-97" data-mp="286zr1rvn0p3e">
                  hs
                </div>
              </div>
              <div className="font-display font-black text-[34px] md:text-[46px] py-2 text-brandViolet flex items-center" data-id="element-98" data-mp="1fi29jqz92wbp">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandViolet rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(139,92,246,0.4)]" data-id="element-99" data-mp="1u7zxq6x6jm0w">
                <div className="font-display font-black text-[34px] md:text-[46px] text-brandViolet leading-none" data-id="element-100" data-mp="wqt0fite69kn">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandViolet mt-1" data-id="element-101" data-mp="3d4uwnmfgjoc0">
                  min
                </div>
              </div>
              <div className="font-display font-black text-[34px] md:text-[46px] py-2 text-brandViolet flex items-center" data-id="element-102" data-mp="2zbn6lz70z0wf">
                :
              </div>
              <div className="bg-bg-card border-2 border-brandViolet rounded-[14px] w-[72px] h-[80px] md:w-[90px] md:h-[96px] flex flex-col items-center justify-center shadow-[0_0_25px_rgba(139,92,246,0.4)]" data-id="element-103" data-mp="3r5xji1ea12nz">
                <div className="font-display font-black text-[34px] md:text-[46px] text-brandViolet leading-none" data-id="element-104" data-mp="3i3g2q2he528d">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[9px] md:text-[11px] text-brandViolet mt-1" data-id="element-105" data-mp="26n7txjbd8uo9">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 font-sans font-bold text-base md:text-xl text-gold leading-snug" data-id="element-106" data-mp="32fa9ksd7o0pm">
              <AlertTriangle size={20} data-id="element-107" data-mp="2td98fkeuwuio" />
              <span data-id="element-108" data-mp="2te2ai82vevuh">Después sube el precio. No vuelve.</span>
            </div>

            <div className="p-4 rounded-[14px] border border-line bg-bg-alt" data-id="element-109" data-mp="2oezflgglu608">
              <div className="flex justify-between font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-3" data-id="element-110" data-mp="3m1opechjtmwn">
                <span className="flex items-center gap-2" data-id="element-111" data-mp="3h2lj6opu1an3">
                  <span className="w-2 h-2 rounded-full bg-brandViolet animate-pulse" data-id="element-112" data-mp="3h57r4pgmxs5u"></span>{' '}
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandViolet font-bold" data-id="element-113" data-mp="37ciq6oipnwor">Quedan pocos</span>
              </div>
              <div className="w-full bg-line rounded-full h-2 mb-2 overflow-hidden" data-id="element-114" data-mp="8ommtlyy7n92">
                <div className="bg-brandViolet h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-115" data-mp="3vjt9du68dsv"></div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted text-right" data-id="element-116" data-mp="g6kurm1heqa6">
                71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const includes = [{
    icon: '📚',
    label: '6 Módulos Principales',
    detail: '475 páginas listas para estudiar y aplicar',
    price: 'USD $39'
  }, {
    icon: '🎁',
    label: '5 Bonos Exclusivos',
    detail: 'Afirmaciones, rituales, meditaciones y agenda',
    price: 'USD $40'
  }];
  return <Section className="bg-bg-alt !pt-6 !pb-8 md:!pt-12 md:!pb-14" id="pricing" data-id="element-117" data-mp="13wnglkesz00c">
      <div className="max-w-lg mx-auto" data-id="element-118" data-mp="18tx5myya59nn">
        <FadeIn className="text-center mb-5 md:mb-7" data-id="element-119" data-mp="18x2tkav6a5hs">
          <p className="font-sans text-[12.5px] md:text-[15px] text-txt-body" data-id="element-120" data-mp="1dvmimk52bxed">
            Estás a un paso de tener todo tu sistema completo...
          </p>
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[40px] leading-[1.15] text-txt-primary mt-2 max-w-[18ch] md:max-w-none mx-auto" data-id="element-121" data-mp="2hc0j2dd6m3t7">
            OFERTA ESPECIAL DE{' '}
            <span className="text-brandViolet" data-id="element-122" data-mp="2rag7g8ktqyz0">LANZAMIENTO</span>
          </h2>
          <p className="font-sans text-[11.5px] md:text-[14px] leading-[1.45] text-txt-muted mt-1.5" data-id="element-123" data-mp="2rcklhjcfted0">
            Módulos, bonos y 475 páginas listas en un solo acceso.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-124" data-mp="3091y6r0g9kav">
          <div className="relative rounded-[20px] md:rounded-[24px] border-2 border-brandViolet bg-bg-card px-4 pt-7 pb-4 md:px-7 md:pt-9 md:pb-6 shadow-[0_0_60px_rgba(139,92,246,0.22),inset_0_0_30px_rgba(139,92,246,0.03)]" data-id="element-125" data-mp="359fvbe0ij9u4">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandViolet text-white font-sans font-bold uppercase tracking-[1.5px] text-[9.5px] md:text-[11px] px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(139,92,246,0.5)]" data-id="element-126" data-mp="3eyhax335bp7k">
              ⭐ MÁS ELEGIDO
            </div>

            <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted text-center mb-3 md:mb-4" data-id="element-127" data-mp="1cdwty82qh10f">
              Lo que incluye tu Biblioteca
            </p>

            <ul className="divide-y divide-line border-y border-line" data-id="element-128" data-mp="13d8gbeh952o2">
              {includes.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5 md:py-3" data-id="element-129" data-mp="yedvk6zq541b">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-130" data-mp="1v2blqxkvkj2a">
                    <span className="text-[15px] md:text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-131" data-mp="1r1hxg33it28v">
                      {item.icon}
                    </span>
                    <div className="min-w-0" data-id="element-132" data-mp="1m96z34ofhoif">
                      <p className="font-sans font-bold text-[12.5px] md:text-[15px] text-txt-primary leading-snug" data-id="element-133" data-mp="1hczzdtmml98x">
                        {item.label}
                      </p>
                      <p className="font-sans text-[10.5px] md:text-[12.5px] leading-[1.35] text-txt-muted" data-id="element-134" data-mp="2a15kihhld09a">
                        {item.detail}
                      </p>
                    </div>
                  </div>
                  <span className="font-sans font-bold text-[12.5px] md:text-[15px] line-through text-danger shrink-0" data-id="element-135" data-mp="2xwh468qpq89t">
                    {item.price}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 text-center" data-id="element-136" data-mp="2o535u4ahzei9">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-txt-muted" data-id="element-137" data-mp="2a6whberfuqv9">
                Precio original
              </p>
              <p className="font-display font-black text-[20px] md:text-[26px] leading-none line-through text-danger mt-1" data-id="element-138" data-mp="2f3munubuz8cz">
                USD $79
              </p>
            </div>

            <div className="mt-3 md:mt-4 rounded-[16px] border border-brandViolet/30 bg-bg-alt px-4 py-3.5 md:py-5 text-center" data-id="element-139" data-mp="2581xc9hqiw9k">
              <p className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandViolet" data-id="element-140" data-mp="3vi4uqd0hlwdf">
                Acceso completo hoy por
              </p>
              <p className="font-display font-black text-[42px] md:text-[58px] leading-none text-brandViolet mt-1" data-id="element-141" data-mp="1nyhd09r4no44">
                $15{' '}
                <span className="font-sans font-bold text-[14px] md:text-[18px] align-middle" data-id="element-142" data-mp="1xokc8roudyaw">
                  USD
                </span>
              </p>
              <p className="font-sans text-[10.5px] md:text-[13px] text-txt-muted mt-1.5" data-id="element-143" data-mp="1svzi1p20xj6u">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <LocalCurrencyNote className="mt-3 md:mt-4" data-id="element-144" data-mp="22mu8z6q7t6ym" />

            <div className="mt-4 md:mt-5" data-id="element-145" data-mp="2gn508avfsnkb">
              <CTAButton href={PRODUCTS.biblioteca.checkoutUrl} fullWidth trackingProduct="biblioteca" onClick={markCheckoutStarted} className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-146" data-mp="2gm3lnwf7pixu">
                💜 QUIERO LA BIBLIOTECA COMPLETA
              </CTAButton>
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-2.5 md:mt-3.5 font-sans text-[10px] md:text-[12.5px] text-txt-muted" data-id="element-147" data-mp="hau5fd6c8vxk">
                <span data-id="element-148" data-mp="nq15vjqzr3uv">🔒 Pago seguro</span>
                <span data-id="element-149" data-mp="nopyl9yc7dz0">⚡ Acceso en minutos</span>
                <span data-id="element-150" data-mp="sp49r0v8j419">🛡️ Garantía 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};